import { AxiosResponse } from 'axios'
import { useEffect, useState } from 'react'

export const useQuery = <ResponseType, RequestType>(
  fetcher: (req?: RequestType) => Promise<AxiosResponse<ResponseType, unknown>>,
  callback?: (data: ResponseType) => void,
) => {
  const [fetching, setFetching] = useState(false)
  const [isFetched, setIsFetched] = useState(false)
  const [isError, setIsError] = useState(false)
  const [isSuccess, setIsSuccess] = useState(false)
  const [data, setData] = useState<ResponseType>({} as ResponseType)

  const fetchData = (req?: RequestType) => {
    setFetching(true)
    return (
      fetcher(req)
        .then(res => {
          if (res.status === 200) {
            setData(res.data)
            callback?.(res.data)
            setIsSuccess(true)
            return Promise.resolve(res)
          }
          throw new Error()
        })
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((error: any) => {
          setIsError(true)
          return Promise.reject(error)
        })
        .finally(() => {
          setFetching(false)
          setIsFetched(true)
        })
    )
  }

  useEffect(() => {
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    fetchData,
    isFetched,
    isSuccess,
    isError,
    data,
    fetching,
  }
}
